import Votacao from "../Votacao";

export default function Nicho() {
  return <Votacao colecao="nicho" titulo="Perfumes de Nicho" />;
}
